import { Module, GetterTree, MutationTree } from 'vuex';
import { IAIJobTrackerState, AIJobTrackerState } from './ai-job-tracker-states.store';
import mutations from './ai-job-tracker-mutations.store';
import getters from './ai-job-tracker-getters.store';

export class AIJobTrackerModule<RootState> implements Module<IAIJobTrackerState, RootState> {
    namespaced: boolean;
    state: IAIJobTrackerState;
    getters: GetterTree<IAIJobTrackerState, RootState>;
    mutations: MutationTree<IAIJobTrackerState>;

    constructor() {
        this.namespaced = true;
        this.state = new AIJobTrackerState();
        this.mutations = mutations;
        this.getters = getters;
    }
}
